import gql from "graphql-tag";

// id_bodega, id_sociedad e id_sucursal necesitan el backend 65479501 o posterior.
// Se pueden combinar: las solicitudes respetan los tres, y para los lotes por
// vencer el backend usa id_bodega y, solo si no viene, mira sociedad y sucursal.
// El Dashboard solo ofrece bodegas que atienden la sociedad y la sucursal
// elegidas (ver Dashboard.vue).
export const DASHBOARD_EPP = gql`
  query dashboardSolicitudes(
    $id_formulario: Int!
    $fecha_inicio: String
    $fecha_final: String
    $id_extremidad: Int
    $id_bodega: Int
    $id_sociedad: Int
    $id_sucursal: Int
    $id_area: Int
  ) {
    dashboardSolicitudes(
      id_formulario: $id_formulario
      fecha_inicio: $fecha_inicio
      fecha_final: $fecha_final
      id_extremidad: $id_extremidad
      id_bodega: $id_bodega
      id_sociedad: $id_sociedad
      id_sucursal: $id_sucursal
      id_area: $id_area
    ) {
      totalSolicitudes
      solicitudesByEstado
      solicitudesByTurno
      totalProductosByCategoria
      solicitudesByCategoria
      listProductos
      solicitudesByAreaAndMonth {
        mes
        solicitudesByArea
      }
      solicitudesByGeneroAndTalla {
        Producto
        totalByGenero
        totalByTalla
      }
      topLotesVencimiento
      topSolicitantesPorArea
      topEPPSolicitados
      totalProductosDesgloceByCategoria
    }
  }
`;

export const EPP_GERENCIAS_BUSINESS_UNIT = gql`
  query GerenciasBusinessUnit {
    gerenciasBusinessUnit {
      id_gerencia
      nombre_gerencia
      bussiness_unit
      unit_number
    }
  }
`;

export const GET_BODEGAS_BY_PRODUCTO = gql`
  query GetBodegasByProducto($idProducto: Int!) {
    GetBodegasByProducto(id_producto: $idProducto) {
      id_producto_bodega
      id_bodega
      nombre
      lotes {
        id
        lote
        stock_real
        stock_entregado
        fecha_vencimiento
      }
    }
  }
`;

export const LIST_ESTADOS_EPP = gql`
  query listEstadosFormulario($id_formulario: Int!) {
    listEstadosFormulario(id_formulario: $id_formulario) {
      id_estado
      nombre
      descripcion
      color
      orden
      can_rollback
      is_active
    }
  }
`;

export const LIST_CATEGORIAS_EPP = gql`
  query GetCategoriasEPP($id_formulario: Int!) {
    GetCategoriasEPP(id_formulario: $id_formulario) {
      id_categoria
      nombre
    }
  }
`;

export const PAGINACION_EPPS = gql`
  query paginacionEpp(
    $idFormulario: Int!, $limite: Int!, $nombre: String
  ) {
    paginacionEpp(id_formulario: $idFormulario, limite: $limite, nombre: $nombre) {
      epps
    }
  }
`;

export const EPP_BODY = `
{
    nombre_producto
    orden
    codigo_producto
    stock_general
    has_talla
    estado_general
    periodicidad
    productos {
      id_producto
      nombre
      descripcion
      url_imagen
      categoria {
        id_categoria
        nombre
        categoria {
          id_categoria
          nombre
        }
      }
      precio
      sku
      barcode
      ceco
      color
      genero
      codigo_producto
      id_estado_fk
      talla {
        id_talla
        nombre
      }
      limite {
        limite
      }
      stock {
        stock_real
        stock_reservado
      }
      bodegas {
        id_producto_bodega
        id_bodega
        nombre
        lotes {
          id
          lote
          stock_real
          stock_entregado
          fecha_vencimiento
        }
      }
    }
  }
`;

export const LIST_EPPS = gql`
  query ListaEPP($ids: [Int]) {
    ListaEPP(ids: $ids) ${EPP_BODY}
  }
`;

export const LIST_EPPS_SIMPLE = gql`
  query ListaEPP($ids: [Int]) {
    ListaEPP(ids: $ids) {
      nombre_producto
      codigo_producto
    }
  }
`;

export const LIST_SOLICITUDES_EPP = gql`
  query listSolicitudesByArgs(
    $creado_por: Int
    $pagina: Int!
    $idEstado: Int
    $fechaInicio: String
    $fechaFinal: String
    $id_formulario: Int!
    $nombreUsuario: String
  ) {
    listSolicitudesByArgs(
      creado_por: $creado_por
      pagina: $pagina
      nombre_usuario: $nombreUsuario
      fecha_inicio: $fechaInicio
      fecha_final: $fechaFinal
      id_estado: $idEstado
      id_formulario: $id_formulario
    ) {
      previous_page
      next_page
      count
      total_pages
      data {
        id_solicitud
        id_usuario_fk
        id_formulario_fk
        estado_solicitud {
          id_estado
          nombre
          color
        }
        ceco
        ot
        error
        fecha_creacion
        respuestas {
          cantidad_solicitada
          cantidad_modificada
          cantidad_entregada
          input
          fecha_usoexp
          lotes {
            id
            cantidad_entregar
            id_lote_fk
            id_respuesta_fk
            lote {
              id
              lote
              stock_real
              stock_entregado
              fecha_vencimiento
            }
          }
          campo {
            id_campo
            nombre
            header
          }
          opcion {
            id_opcion
            nombre
            descripcion
          }
          producto {
            id_producto
            codigo_producto
            nombre
            descripcion
            url_imagen
            precio
            sku
            barcode
            ceco
            color
            genero
            periodicidad
            categoria {
              nombre
              id_categoria
              categoria {
                id_categoria
                nombre
              }
            }
            talla {
              id_talla
              nombre
            }
          }
        }
        usuarios {
          id_usuario
          primer_nombre
          apellido_paterno
          telefono_movil
          telefono_fijo
          correo
          empresa_cargos {
            id_cargo
            nombre_cargo
          }
          gerencia {
            nombre_gerencia
          }
        }
        colaborador {
          id_usuario
          primer_nombre
          apellido_paterno
          telefono_movil
          telefono_fijo
          correo
          empresa_cargos {
            id_cargo
            nombre_cargo
          }
          gerencia {
            nombre_gerencia
          }
        }
        codigo_solicitud
        firma {
          document_url
          fecha_fima
        }
      }
    }
  }
`;

export const REPORTE_SOLICITUDES_EPP_PRECIOS = gql`
  query ReporteEPPPrecios(
    $idFormulario: Int!
    $isEntregadas: Boolean!
    $fechaFinal: String
    $fechaInicio: String
  ) {
    ReporteEPPPrecios(
      id_formulario: $idFormulario
      is_entregadas: $isEntregadas
      fecha_final: $fechaFinal
      fecha_inicio: $fechaInicio
    ) {
      epp
      sku
      tallas {
        sku
        talla
      }
      precio
      cantidad_solicitada
      precio_total
    }
  }
`;

export const REPORTE_SOLICITUDES_EPP = gql`
  query reportesSolicitudes(
    $id_formulario: Int!
    $fecha_inicio: String
    $fecha_final: String
    $id_gerencia: Int
    $codigo_producto: Int
  ) {
    reportesSolicitudes(
      id_formulario: $id_formulario
      fecha_inicio: $fecha_inicio
      fecha_final: $fecha_final
      id_gerencia: $id_gerencia
      codigo_producto: $codigo_producto
    ) {
      id_solicitud
      codigo_solicitud
      fecha_creacion
      estado_solicitud {
        id_estado
        nombre
      }
      usuarios {
        id_usuario
        primer_nombre
        apellido_paterno
        rut_usuario
        dv_usuario
        # Empresa y centro de trabajo del solicitante (no del colaborador)
        sociedad {
          nombre_sociedad
        }
        sucursal {
          nombre_sucursal
        }
        gerencia {
          nombre_gerencia
        }
      }
      respuestas {
        cantidad_solicitada
        cantidad_entregada
        producto {
          id_producto
          codigo_producto
          nombre
          sku
        }
        # De qué lote y bodega se descontó lo entregado
        lotes {
          id
          cantidad_entregar
          lote_nombre
          nombre_bodega
        }
      }
      fecha_modificacion
      firma {
        fecha_fima
        document_url
      }
      ot
      # El backend lo arma con el bussiness_unit de la gerencia del colaborador
      centro_costo
    }
  }
`;

export const LIST_BODEGAS_EMPRESA = gql`
  query ListBodegasEmpresa {
    ListBodegasEmpresa {
      id_bodega
      nombre
    }
  }
`;

// LIST_BODEGAS_EMPRESA más la segmentación de cada bodega. Solo se usa con
// BODEGAS_CON_SUCURSALES_Y_SOCIEDADES (store/modules/epp/Bodega.js).
//
// Se piden las dos formas porque las dos hacen falta:
// - `sociedades` es la jerarquía real (cada sociedad con SUS sucursales) y trae
//   los nombres ya resueltos por el backend, así que la lista de bodegas no
//   necesita usersModule para mostrarlos.
// - `id_sucursales` / `id_sociedades` son las listas planas de siempre. Una
//   bodega guardada solo con sucursales, sin ninguna sociedad, no genera filas
//   en si_bodega_ss y vuelve con `sociedades` vacío: esas sucursales aparecen
//   únicamente en la lista plana.
//
// El campo `sociedades` necesita el backend 65479501 o posterior. Contra uno
// anterior no existe en el esquema y falla la query entera, no solo el campo.
export const LIST_BODEGAS_EMPRESA_CON_SEGMENTACION = gql`
  query ListBodegasEmpresa {
    ListBodegasEmpresa {
      id_bodega
      nombre
      id_sucursales
      id_sociedades
      sociedades {
        id_sociedad
        nombre_sociedad
        id_sucursales
        sucursales {
          id_sucursal
          nombre_sucursal
        }
      }
    }
  }
`;

// Cada sociedad (empresa) de la empresa del token con las sucursales donde tiene
// trabajadores. Es la relación sociedad -> sucursales que BodegasModal necesita
// para ofrecerle a cada sociedad solo las suyas: el tipo Sucursal no dice a cuál
// pertenece.
//
// No es una tabla: el backend la arma con los usuarios activos, así que una
// sucursal sin trabajadores en esa sociedad no aparece. Todos los ids llegan como
// String. Sin argumentos a propósito: el resolver deja que `id_empresa` gane al
// token, y el admin quiere siempre la empresa del token.
//
// Necesita el backend 4e2a40b5 o posterior. Contra uno anterior falla solo esta
// consulta (es un campo raíz aparte): el modal lo toma como "sin relación" y ofrece
// todas las sucursales, como antes (ver getSociedadesSucursales en
// store/modules/epp/Bodega.js).
export const GET_SOCIEDADES_SUCURSALES = gql`
  query GetSociedadesSucursales {
    GetSociedadesSucursales {
      id_sociedad
      nombre_sociedad
      sucursales {
        id_sucursal
        nombre_sucursal
      }
    }
  }
`;

export const LIST_JEFES = gql`
  query ListJefes {
    ListJefes {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo {
        id_cargo
        nombre_cargo
      }
      colaboradores {
        id_relacion
        colaborador {
          id_usuario
          primer_nombre
          apellido_paterno
          cargo {
            id_cargo
            nombre_cargo
          }
          sucursal {
            id_sucursal
            nombre_sucursal
          }
        }
      }
    }
  }
`;

export const GET_FORMULARIO_BY_TIPO_ADMIN = gql`
  query GetFormularioByTipoAdmin {
    GetFormularioByTipoAdmin(id_tipo: 6) {
      id_formulario,
      nombre,
      descripcion,
      has_lotes,
      tipo_formulario {
        id_tipo
      },
      integracion{
        id_tipo,
        nombre,
        is_automatico
      }
    }
  }
`;
export const GET_LIST_TIPO_PERIODOS_EPP = gql`
query ListTipoPeriodosEPP {
  ListTipoPeriodosEPP {
    id_tipo
    nombre
    cantidad_dias
  }
}
`;

export const GET_LIST_TIPO_VALIDACIONES_EPP = gql`
query ListTipoValidacionesEPP {
  ListTipoValidacionesEPP {
    id_tipo
    nombre
    parametro
  }
}`;

export const FIND_ALL_CONDICIONES_SOLICITUDES_AUTOMATICAS = gql`
query FindAllCondicionesSolicitudesAutomaticas($idFormulario: Int!) {
  FindAllCondicionesSolicitudesAutomaticas(id_formulario: $idFormulario) {
    id_periodo_empresa
    id_formulario_fk
    formulario {
      tipo_formulario {
        id_tipo
        nombre
        descripcion
        url_imagen
      }
    }
    periodo {
      id_tipo
      nombre
      cantidad_dias
    }
    validacion {
      id_condicion
      c_cargo
      c_area
      c_sucursal
      c_turno
      c_sindicato
      c_nacimiento_desde
      c_nacimiento_hasta
      c_ingreso_desde
      c_ingreso_hasta
      tipo {
        id_tipo
        nombre
        parametro
      }
    }
    productos {
      codigo_producto
      producto {
        id_producto
        nombre
        descripcion
        categoria {
          id_categoria
          nombre
          categoria {
            id_categoria
            nombre
          }
        }
        precio
        sku
        barcode
        ceco
        color
        genero
        codigo_producto
        id_estado_fk
        talla {
          id_talla
          nombre
        }
        limite {
          limite
        }
        stock {
          stock_real
          stock_reservado
        }
        bodegas {
          id_bodega
          id_producto_bodega
          lotes {
            stock_entregado
            stock_real
            lote
            id
            fecha_vencimiento
          }
          nombre
        }
      }
    }
    ejecucion {
      id_ejecucion
      dia_ejecucion
      fecha_ejecucion
    }
  }
}`;

// Encargados del formulario de EPP: reciben las solicitudes de trabajadores
// sin jefatura y copia de las aprobaciones y rechazos. ListEncargados trae la
// gerencia como empresa_gerencias. Su sucursal y su sociedad llegan en null (el
// backend las arma como lista sobre un campo de objeto): se piden aparte con
// EMPRESA_Y_CENTRO_USUARIOS.
export const LIST_ENCARGADOS = gql`
  query ListEncargados($id_formulario: Int) {
    ListEncargados(id_formulario: $id_formulario) {
      id_encargado
      id_usuario_fk
      encargado {
        id_usuario
        primer_nombre
        apellido_paterno
        correo
        imagen_perfil
        empresa_cargos {
          nombre_cargo
        }
        empresa_gerencias {
          nombre_gerencia
        }
      }
    }
  }
`;

// LIST_ENCARGADOS más el rol y las bodegas de cada encargado. Solo se usa con
// ENCARGADOS_CON_BODEGAS (store/modules/epp/Encargados.js). rol_encargado lo
// calcula el backend: "superadministrador", "administrador_local", "panolero" o
// "sin_rol"
export const LIST_ENCARGADOS_CON_BODEGAS = gql`
  query ListEncargados($id_formulario: Int) {
    ListEncargados(id_formulario: $id_formulario) {
      id_encargado
      id_usuario_fk
      is_supervisor
      rol_encargado
      encargado {
        id_usuario
        primer_nombre
        apellido_paterno
        correo
        imagen_perfil
      
        empresa_cargos {
          nombre_cargo
        }
        empresa_gerencias {
          nombre_gerencia
        }
      }
      bodegas {
        id_bodega
        nombre
      }
    }
  }
`;

// Catálogo de permisos de EPP, agrupado: "Permisos de solicitud" (solo jefe /
// colaborador) y "Automatizaciones de solicitudes" (se usan / no se usan).
// Los ids llegan como String
export const GET_PERMISOS_SI = gql`
  query GetPermisosSi {
    GetPermisosSi {
      titulo
      opciones {
        id_permiso
        nombre_permiso
        solo_jefe
        colaborador
        automatizaciones
      }
    }
  }
`;

// Permisos elegidos por la empresa del token
export const GET_PERMISO_SI_EMPRESA = gql`
  query GetPermisoSiEmpresa {
    GetPermisoSiEmpresa {
      id_permiso_empresa
      permiso {
        id_permiso
        solo_jefe
        colaborador
        automatizaciones
      }
    }
  }
`;

// Rol del usuario en EPP: "superadministrador", "administrador_local", "panolero"
// o "sin_privilegio". Lo usa store/modules/epp/epp.js (rutasEppPermitidas)
export const GET_PERFIL_ENCARGADO = gql`
  query GetPerfilEncargado($id_formulario: Int) {
    GetPerfilEncargado(id_formulario: $id_formulario) {
      id_usuario
      rol
    }
  }
`;

// Privilegio de cada usuario (privilegio[0].id_tipo), para enviarlo como
// id_privilegio_fk al crear o editar encargados. El buscador de encargados
// (ListContactosUsuarios) no lo trae
export const PRIVILEGIOS_USUARIOS = gql`
  query listUsersPaginacion($id_usuario: [String]!) {
    listUsersPaginacion(id_usuario: $id_usuario) {
      id_usuario
      privilegio {
        id_tipo
      }
    }
  }
`;

// Empresa (sociedad) y centro de trabajo (sucursal) de cada usuario, para los
// encargados y su buscador: ListEncargados los trae en null y
// ListContactosUsuarios no trae la sociedad. Llegan como lista de un elemento
export const EMPRESA_Y_CENTRO_USUARIOS = gql`
  query listUsersPaginacion($id_usuario: [String]!) {
    listUsersPaginacion(id_usuario: $id_usuario) {
      id_usuario
      sociedad {
        id_sociedad
        nombre_sociedad
      }
      sucursal {
        id_sucursal
        nombre_sucursal
      }
    }
  }
`;
